// Authenticated member routes — AppLayout shell (doc 04 §8/§9).
import type { RouteRecordRaw } from 'vue-router'

export const appRoutes: RouteRecordRaw[] = [
  {
    path: '/app/dashboard',
    name: 'app-dashboard',
    component: () => import('@/pages/app/DashboardPage.vue'),
    meta: { layout: 'app', requiresAuth: true, title: 'Dashboard' },
  },
  {
    path: '/bookings',
    name: 'my-bookings',
    component: () => import('@/pages/app/MyBookingsPage.vue'),
    meta: { layout: 'app', requiresAuth: true, title: 'My Bookings' },
  },
]
